
export default function Footer() {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-2 mb-6">
              <div className="w-10 h-10 bg-gradient-to-r from-pink-400 to-teal-400 rounded-full flex items-center justify-center">
                <i className="ri-palette-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-bold" style={{ fontFamily: 'Pacifico, serif' }}>
                Ms Plantage
              </h3>
            </div>
            
            <p className="text-gray-300 mb-6 leading-relaxed">
              株式会社Ｍｓ　Ｐｌａｎｔａｇｅは、ネイルアートを通じて一人ひとりの個性と美しさを引き出すことを使命としています。
              性別や年齢を問わず、すべてのお客様に質の高いサービスを提供いたします。
            </p>
            
            <div className="text-gray-400 text-sm">
              <p>〒546-0043</p>
              <p>大阪府大阪市東住吉区駒川3-27-39</p>
              <p>プレジオールKOMAGAWA２０４</p>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-6">クイックリンク</h4>
            <ul className="space-y-3">
              <li>
                <button 
                  onClick={() => scrollToSection('home')}
                  className="text-gray-300 hover:text-pink-400 transition-colors cursor-pointer"
                >
                  ホーム
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('services')}
                  className="text-gray-300 hover:text-pink-400 transition-colors cursor-pointer"
                >
                  サービス
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('gallery')}
                  className="text-gray-300 hover:text-pink-400 transition-colors cursor-pointer"
                >
                  ギャラリー
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('about')}
                  className="text-gray-300 hover:text-pink-400 transition-colors cursor-pointer"
                >
                  会社概要
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('contact')}
                  className="text-gray-300 hover:text-pink-400 transition-colors cursor-pointer"
                >
                  お問い合わせ
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-6">サービス</h4>
            <ul className="space-y-3">
              <li>
                <span className="text-gray-300">ネイルレッスン</span>
              </li>
              <li>
                <span className="text-gray-300">オンラインレッスン</span>
              </li>
              <li>
                <span className="text-gray-300">ネイル商品販売</span>
              </li>
              <li>
                <span className="text-gray-300">通信販売</span>
              </li>
            </ul>
            
            
          </div>
        </div>

        <div className="border-t border-gray-700 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © {currentYear} 株式会社Ｍｓ　Ｐｌａｎｔａｇｅ. All rights reserved.
            </p>
           
          </div>
        </div>
      </div>
    </footer>
  );
}
